exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[class*=\"stage_stage\"] {\n  border-radius: 0rem !important;\n}\n\n[class*=\"stage_green-flag-overlay-wrapper\"] {\n  border-radius: 0rem !important;\n}\n", ""]);

// exports
